//
//
//
//
//
//

export default {
    data() {
        return {
            first: '',
            second: ''
        }
    },
    methods: {
        setForm(params) {
            this.first = params.split('(')[0]
            this.second = params.substr(params.length - 2, 1)
        },
        firstInputFocus() {
            this.$emit('first-input-focus', {first: this.first, second: this.second})
        },
        emit(target, params) {            
            this[target] = params
            // 移动光标
            let result = false
            let firstInput = this.first
            let regExp = new RegExp("\^[A-Z]{2}[0-9]{6}$")
            let exp1 = regExp.test(firstInput)
            let regExp2 = new RegExp("\^[A-Z]{1}[0-9]{6}$")
            let exp2 = regExp2.test(firstInput)
            if (exp1 || exp2) {
                console.log('匹配到用戶輸入的身份證號，跳第二個輸入框')
                result = true
            }
            if(result && !this.second) {
                this.$refs.second.focus()            
                this.$emit('second-input-foucus', {first: this.first, second: this.second})
            }
            this.$emit('input', `${this.first}${this.second}`)
            this.$emit('change', {first: this.first, second: this.second})
        },
        getForm() {
            return `${this.first}${this.second}`
        }
    }
}
